const destinationChargeSlabUnit = () => ({
  KG: 'KG',
  CFT: 'CFT',
  KM: 'KM',
  BOX: 'BOX',
  CASE: 'CASE',
});

module.exports = {
  destinationChargeSlabUnit,
};
